<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import "./assets/css/common.scss"
    export default {
        name      : 'App',
        components: {
        },
        data() {
            return {
                routerIncludes: []
            }
        },
        // mounted() {
        //     this.$router.replace({name: "Home"})
        // }
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        padding: 0;
        margin: 0;
        background: #FCF5F5;
        width: 100%;
        height: 100%;
    }
</style>
